import { TFunction } from "i18next";
import * as Yup from "yup";

export const supplementsValidationSchema = (t: TFunction) =>
    Yup.object().shape({
        groupName: Yup.string().required(t("validation.required")),
        items: Yup.array().of(Yup.number()),
        options: Yup.array()
            .of(
                Yup.object().shape({
                    name: Yup.string().required(t("validation.required")),
                    price: Yup.number().required(t("validation.required")),
                })
            )
            .min(1, t("At least one option is required"))
            .test("unique-option-names", t("An add-on/option with this name already exists"), function (options) {
                if (!options) return true;

                const names = options.map((opt) => (opt?.name ?? "").trim().toLowerCase());

                const indicesByName = new Map<string, number[]>();

                names.forEach((name, index) => {
                    if (!name) return;
                    const list = indicesByName.get(name) ?? [];
                    list.push(index);
                    indicesByName.set(name, list);
                });

                const errorIndexes: number[] = [];
                indicesByName.forEach((indexes) => {
                    if (indexes.length > 1) {
                        errorIndexes.push(...indexes.slice(1));
                    }
                });

                if (errorIndexes.length === 0) {
                    return true;
                }

                const errors = errorIndexes.map((idx) =>
                    this.createError({
                        path: `options[${idx}].name`,
                        message: t("An add-on/option with this name already exists"),
                    })
                );
                return new Yup.ValidationError(errors);
            }),
        maxCountOnOrder: Yup.number().required(t("validation.required")).min(1, t("Must select at least one option")),
    });
